import { useEffect, useState } from "react"
import { useScope, useUser } from "../../../container/SelectProjectCompanyContainer"
import Send from "../../communication"
import { customToast } from "../../../components/Toast"

export const useEvents = () => {
  const [events, setEvents] = useState([])
  const [calendarEvents, setCalendarEvents] = useState([])
  const { scope, scopeType } = useScope()
  const user = useUser();
  const [reload, setReload] = useState(false)

  useEffect(() => {
    Send.get(`/events/project/${scope?.id}/${user?.id}`, `scopeType=${scopeType}`)
      .then((response) => {
        setEvents(response)
      })
      .catch((error) => {
        customToast("Erro ao buscar eventos.", 'error');
        console.log("Erro ao buscar eventos. ", error)
      })
  }, [scope, reload])

  useEffect(() => {
    setCalendarEvents(events)
  }, [events])

  return [calendarEvents, setReload]
}

export const useEventsPost = (eventId, typeEvent) => {
  const [selectedPosts, setSelectedPosts] = useState([])

  const loadEventPosts = async () => {
    if (eventId) {
      const res = await Send.get(`/events-post/event/${eventId}`)
      const posts = res?.length && res?.map((item) => item.post.map((item) => item.id)).flat()
      posts && posts?.length > 0 && setSelectedPosts(posts)
      
    }
    else {
    setSelectedPosts([])
    }
  }

  useEffect(() => {
    if(typeEvent === "Envio de Conteúdo" && eventId){
      loadEventPosts()
    }
  }, [typeEvent, eventId])

  return {selectedPosts, setSelectedPosts}
}

export const useEventsSector = (eventId, setValueHookForm) => {
  const [receivedEventsSectorId, setReceivedEventsSectorId] = useState("")
  const [isRemoveSectorEvent, setIsRemoveSectorEvent] = useState(false);
  const [reload, setReloadSector] = useState(false)

  const loadEventsSector = async () => {
    if(eventId){
      let response = []

    response = await Send.get(`/events-sector/event/${eventId}`)
    
    const usersReceived = response && response?.users?.map(({ id, name }) => ({
      value: id,
      label: name,
    }))

    const tagsReceived = response && response?.tags?.map(({ id, name }) => ({
      value: id,
      label: name,
    }))


    setValueHookForm("usersEvent", usersReceived)
    setValueHookForm("tagsEvent", tagsReceived)
    setIsRemoveSectorEvent(response?.isRemoveEvent);
    setReceivedEventsSectorId(response && response?.id)
    }
  }

  useEffect(() => {
    if(eventId || reload){
      loadEventsSector()
    }
  }, [eventId, reload])

  return { receivedEventsSectorId, isRemoveSectorEvent, setReloadSector  }
}
